module.exports = __webpack_public_path__ + "static/media/chart-81k-v2.6fe40ffd.svg";